module.exports = __webpack_public_path__ + "img/avatar_santa.99901e17.svg";